import * as React from "react"

import { getClient } from '../../../api/graphql'
import { ApolloProvider } from "react-apollo";
import { PageLoader } from "../../shared/loaders/PageLoader";
import { RentalContentQuery, query, variables, QueryResult, AdvertiserInfoAssets, Routes } from "../../../api/queries/rental/content";
import { IntlProvider } from "react-intl";
import CrumbTrail from "../../shared/advert/CrumbTrail";
import { AdvertiserInfo } from "../../shared/advert/AdvertiserInfo";
import * as Assets from "../../../api/assets";

import Content from "../../rental/Content";
import { ContentMapType } from "../../shared/advert/ContentMap";
import { ToDictionary } from "../../../api/routes";
import { AsyncState, loadingAsyncState, unloadedAsyncState } from "widgets-for-react";
import { VerifiedAspect } from "../../../types/types";
import { fetchVerifiedAspects } from "../../../api/fetch";

type SProps = {
  advert_id: number
  data: QueryResult
  locale: string
}

type State = {
  tooltip_open: boolean
  mapType: ContentMapType
  verifiedAspects: AsyncState<VerifiedAspect[]>
}

class StatefullAdvertContent  extends React.Component<SProps, State> {
  constructor(props: SProps) {
    super(props)
    this.state = {
      tooltip_open: false,
      mapType: 'static',
      verifiedAspects: loadingAsyncState(() =>
        fetchVerifiedAspects(this.props.advert_id, 'rentalAdvert')
      )
    }
  }

  render() {
    const assets = Assets.ToDictionary<AdvertiserInfoAssets>(this.props.data.assets)

    return (
      <Content
        advert={this.props.data.rental_advert}
        placeholderImage={assets.get('placeholder_user.png')}
        onTooltipToggle={() => this.setState({tooltip_open: !this.state.tooltip_open})}
        onCloseTooltip={() => this.setState({tooltip_open: false})}
        tooltipOpen={this.state.tooltip_open}
        mapType={this.state.mapType}
        setMapType={(t) => this.setState({mapType: t})}
        mapsIcon={assets.get('google_maps/overview/marker.png')}
        googleMapsKey={this.props.data.siteSettings.googleMapsKey}
        locale={this.props.locale}
        routes={ToDictionary<Routes>(this.props.data.routes)}
        verifiedAspects={this.state.verifiedAspects}
        setVerifiedAspects={s => this.setState({
          ...this.state,
          verifiedAspects: s(this.state.verifiedAspects)
        })}
      />
    )
  }
}

type Props = {
  advert_id: number
  locale: string
}

export default (props: Props) : JSX.Element => {
  const locale = !!props.locale ? props.locale : window.Gites.locale
  I18n.locale = locale
  return <IntlProvider locale={locale}>
    <ApolloProvider client={getClient()}>
      <RentalContentQuery
        query={query()}
        variables={variables(props.advert_id, locale)}
      >
        {({ loading, error, data}) => {
          if(loading) return <PageLoader />
          if(error) return <div></div>
          return (
            <StatefullAdvertContent
              advert_id={props.advert_id}
              data={data}
              locale={locale}
            />
          )
        }}
      </RentalContentQuery>
    </ApolloProvider>
  </IntlProvider>
}
